import { createRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { ApiError } from "../../shared/api/http.js";
import { Button, Card, Field, Input } from "../../shared/ui/index.js";
import { CenteredLayout } from "../../shared/ui/CenteredLayout.js";
import { useChangePassword } from "./auth.api.js";
import { rootRoute } from "../../app/root-route.js";

export const changePasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/change-password",
  component: ChangePasswordScreen,
});

function ChangePasswordScreen() {
  const navigate = useNavigate();
  const change = useChangePassword();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNext] = useState("");

  return (
    <CenteredLayout>
      <Card>
        <h1 className="font-serif text-xl text-stone-900">Nouveau mot de passe</h1>
        <p className="mt-1 text-sm text-stone-500">Requis pour votre première connexion.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            change.mutate(
              { currentPassword, newPassword },
              {
                onSuccess: ({ user }) =>
                  navigate({ to: user.role === "admin" ? "/admin" : "/app" }),
              },
            );
          }}
          className="mt-4 flex flex-col gap-3"
        >
          <Field label="Mot de passe actuel">
            <Input
              type="password"
              required
              value={currentPassword}
              onChange={(e) => setCurrent(e.target.value)}
            />
          </Field>
          <Field label="Nouveau mot de passe (8 caractères min.)">
            <Input
              type="password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNext(e.target.value)}
            />
          </Field>
          {change.error && (
            <p className="text-sm text-rose-600">
              {change.error instanceof ApiError ? change.error.message : "Erreur"}
            </p>
          )}
          <Button type="submit" disabled={change.isPending}>
            Valider
          </Button>
        </form>
      </Card>
    </CenteredLayout>
  );
}
